import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useState } from "preact/hooks";
import { t, translate } from "restaumatic-client";
import { formatFulfillmentMethodType, FulfillmentSettingsTracking, } from "restaumatic-client";
import EditBlock from "./EditBlock";
import RadioField from "./RadioField";
import Alert from "./Alert";
import DeliveryAddressForm from "./DeliveryAddressForm";
import RestaurantDeliveryAddressWarning from "./RestaurantDeliveryAddressWarning";
import FieldLegend from "./FieldLegend";
function FulfillmentMethodForm(props) {
    const { orderDetails, options, controller, deliveryAddressCoordinator, origin, withApartmentInfo, withHiddenNoContactDelivery, onChangeRestaurant, viewType, } = props;
    const { fields } = controller;
    const { fulfillmentMethodType, formattedAddress, isDelivery, isApartmentInfoEmpty, } = orderDetails;
    const [editClicked, setEditClicked] = useState(false);
    const isNotSelected = fields.fulfillmentMethod.value === null;
    const isApartmentInfoIncomplete = isDelivery && withApartmentInfo && isApartmentInfoEmpty;
    const isFormVisible = editClicked ||
        !fulfillmentMethodType ||
        isApartmentInfoIncomplete ||
        controller.isDirty ||
        controller.isInvalid;
    return (h("div", null,
        isFormVisible && (h(Fragment, null,
            h(RadioField, { controller: fields.fulfillmentMethod, options: options, name: "fulfillmentMethod", dataFieldId: "fulfillmentMethod.tag", label: translate(t.order.delivery_method), onChange: () => FulfillmentSettingsTracking.chooseMethodEvent(fields.fulfillmentMethod.value, { tag: viewType }) }),
            isDelivery && (h(DeliveryAddressForm, { controller: controller, deliveryAddressCoordinator: deliveryAddressCoordinator, withApartmentInfo: withApartmentInfo, showEmptyMessage: !withApartmentInfo, withHiddenNoContactDelivery: withHiddenNoContactDelivery, viewType: viewType, origin: origin })))),
        !isFormVisible && (h(SelectedView, { type: fulfillmentMethodType, address: formattedAddress, onEdit: () => setEditClicked(true) })),
        isNotSelected && (h(Alert, { type: "info", message: translate(t.restaurants.widgets.cart.cost_info), icon: "info-sign" })),
        isDelivery && (h(RestaurantDeliveryAddressWarning, { state: orderDetails.deliveryAddressStatus, onChangeRestaurant: onChangeRestaurant }))));
}
function SelectedView(props) {
    const { type, address, onEdit } = props;
    const label = translate(t.order.delivery_method);
    const title = formatFulfillmentMethodType(type);
    const description = `${address.firstLine} \n${address.secondLine}`;
    return (h("div", { class: "form-group" },
        h(FieldLegend, { isRequired: true }, label),
        h(EditBlock, { prefixType: "icon", prefixIcon: "location", title: title, description: description, ariaLabel: label, onClick: onEdit })));
}
export default observer(FulfillmentMethodForm);
